export const FETCH_MODEL = 'SELF_SERVICE/MODEL/FETCH_MODEL_REQUEST';
export const FETCH_MODEL_SUCCESS = 'SELF_SERVICE/MODEL/FETCH_MODEL_SUCCESS';
export const FETCH_MODEL_FAILURE = 'SELF_SERVICE/MODEL/FETCH_MODEL_FAILURE';

export const FETCH_SUMMARY_PDF = 'SELF_SERVICE/FETCH_SUMMARY/REQUEST';
export const FETCH_SUMMARY_PDF_SUCCESS = 'SELF_SERVICE/FETCH_SUMMARY/SUCCESS';
export const FETCH_SUMMARY_PDF_FAILURE = 'SELF_SERVICE/FETCH_SUMMARY/FAILURE';

export const OPEN_SEND_WIZARD = 'SELF_SERVICE/SEND/WIZARD/OPEN';
export const CLOSE_SEND_WIZARD = 'SELF_SERVICE/SEND/WIZARD/CLOSE';
export const SEND_CHECKOUT_READY = 'SELF_SERVICE/SEND/WIZARD/READY';

export const SAVE_INTERVENTION_AND_SEND_SELF_SERVICE = 'SELF_SERVICE/SAVE/SEND';

export const SEND_SELF_SERVICE = 'SELF_SERVICE/SEND_REQUEST';
export const SEND_SELF_SERVICE_SUCCESS = 'SELF_SERVICE/SEND_SUCCESS';
export const SEND_SELF_SERVICE_FAILURE = 'SELF_SERVICE/SEND_FAILURE';

export const GET_ON_SITE_LINK = 'SELF_SERVICE/GET_ON_SITE_LINK/REQUEST';
export const GET_ON_SITE_LINK_SUCCESS = 'SELF_SERVICE/GET_ON_SITE_LINK/SUCCESS';
export const GET_ON_SITE_LINK_FAILURE = 'SELF_SERVICE/GET_ON_SITE_LINK/FAILURE';

export const DELETE_MOBILITY = 'SELF_SERVICE/MOBILITY/DELETE/REQUEST';
export const DELETE_MOBILITY_SUCCESS = 'SELF_SERVICE/MOBILITY/DELETE/SUCCESS';
export const DELETE_MOBILITY_FAILURE = 'SELF_SERVICE/MOBILITY/DELETE/FAILURE';

export const GET_KIOSK_ADMIN_TOKEN = 'SELF_SERVICE/GET_KIOSK_ADMIN_TOKEN/REQUEST';
export const GET_KIOSK_ADMIN_TOKEN_SUCCESS = 'SELF_SERVICE/GET_KIOSK_ADMIN_TOKEN/SUCCESS';
export const GET_KIOSK_ADMIN_TOKEN_FAILURE = 'SELF_SERVICE/GET_KIOSK_ADMIN_TOKEN/FAILURE';
